// FEATURE-34 — Launcher-side theme resolver.
//
// Mirrors the panel's resolveTheme(): unknown name → 'default' with a
// console.warn. Lives separately so the launcher bundle doesn't pull in
// the panel's full token module.

import { THEME_NAMES, type ThemeName } from '@ba/protocol';

const DEFAULT_THEME: ThemeName = 'default';

export function resolveTheme(input: string | null | undefined): ThemeName {
  if (input === null || input === undefined || input === '') {
    return DEFAULT_THEME;
  }
  if ((THEME_NAMES as readonly string[]).includes(input)) {
    return input as ThemeName;
  }
  // eslint-disable-next-line no-console
  console.warn(
    `[BAAssistant] Unknown theme "${input}" — falling back to "${DEFAULT_THEME}". ` +
      `Known: ${THEME_NAMES.join(', ')}.`,
  );
  return DEFAULT_THEME;
}
